module.exports = __webpack_public_path__ + "img/mastercard.e3f90c0a.png";